import { formatDate } from "../utils/formatDate";

// $formatDate(date) -> "Oct 12, 2026" (LEAD-05)
export default {
  install: (app) => {
    app.config.globalProperties.$formatDate = formatDate;
  },
};
